import React from 'react';
import PageContainer from '../../common/components/Page/PageContainer';
import SystemAlertsConfigurationContainer from './components/SystemAlertsConfiguration/SystemAlertsConfigurationContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import './SystemAlertsConfigurationPage.css';

const SystemAlertsConfigurationPage = () => (
  <PageContainer pageName="system-alert-configuration">
    <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_ALERTS}>
      <SystemAlertsConfigurationContainer />
    </PermissionsCheck>
  </PageContainer>
);

export default SystemAlertsConfigurationPage;
